import React from 'react'
import { Slideout, Typography, Button, Avatar, Tag } from '@ann/web-components'
import {
    FolderInformationSlideoutContainer,
    FolderInformationSlideoutHeader,
    FolderInformationSlideoutOwnerWrapper,
    FolderInformationSlideoutOwnerTitle,
    FolderInformationSlideoutOwnerContent,
    FolderInformationSlideoutOwnerContentTitle,
    FolderInformationSlideoutOwnerContentBody,
    FolderInformationSlideoutOwnerContentList,
    FolderInformationSlideoutMetaContainer,
    FolderInformationSlideoutMeta,
    FolderInformationSlideoutActions
} from './FolderInformationSlideout.styled'


const FolderInformationSlideout = ({open, onClose, folderName, ownerName}) => {
    const listSharedWith = [
        {
            name: 'Emma Wilson',
            role: 'Editor'
        },
        {
            name: 'Andrew Nielsen',
            role: 'Editor'
        },
        {
            name: 'Andrew Nielsen',
            role: 'Editor'
        },
    ]
    return (
        <Slideout onClose={onClose} size="medium" open={open}>
            <FolderInformationSlideoutContainer>
                <FolderInformationSlideoutHeader>
                    <Typography
                        category="title"
                        size="large"
                        weight="bold"
                    >
                        Folder Information
                    </Typography>
                    <Typography
                        category="body"
                        size="medium"
                        weight="regular"
                        color="body"
                    >
                        {folderName || 'Folder Name'}
                    </Typography>
                </FolderInformationSlideoutHeader>
                <FolderInformationSlideoutOwnerWrapper>
                    <FolderInformationSlideoutOwnerTitle>
                        <Typography
                            category="subtitle"
                            size="medium"
                            weight="bold"
                        >
                            Owner
                        </Typography>

                        <Button
                            label="Manage Access"
                            size="small"
                            type="secondary"
                        />
                    </FolderInformationSlideoutOwnerTitle>
                    <FolderInformationSlideoutOwnerContent>
                        <FolderInformationSlideoutOwnerContentTitle>
                            <Avatar
                                alt="Default avatar"
                                size="lg"
                                src="https://via.placeholder.com/150"
                            />
                            <Typography
                                category="subtitle"
                                size="small"
                                weight="bold"
                            >
                                {ownerName || 'Owner Name'}
                            </Typography>
                        </FolderInformationSlideoutOwnerContentTitle>
                        <FolderInformationSlideoutOwnerContentBody>
                            <div className="list">
                                {
                                    listSharedWith.map((item) => (
                                        <FolderInformationSlideoutOwnerContentList>
                                            <Avatar
                                                alt="Default avatar"
                                                size="md"
                                                src="https://via.placeholder.com/150"
                                            />
                                            <Typography
                                                category="body"
                                                size="medium"
                                                weight="regular"
                                            >
                                                {`${item.name} - ${item.role}`}
                                            </Typography>
                                        </FolderInformationSlideoutOwnerContentList>
                                    ))
                                }
                            </div>
                            <div className={"all"}>
                                <Tag size="medium" color="informative" text="+5"/>
                            </div>
                        </FolderInformationSlideoutOwnerContentBody>
                    </FolderInformationSlideoutOwnerContent>
                </FolderInformationSlideoutOwnerWrapper>
                <FolderInformationSlideoutMetaContainer>
                    <FolderInformationSlideoutMeta>
                        <Typography
                            category="subtitle"
                            size="small"
                            weight="bold"
                        >
                            Modified
                        </Typography>
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                        >
                            Jul 5, 2025 by {'user name'}
                        </Typography>
                    </FolderInformationSlideoutMeta>

                    <FolderInformationSlideoutMeta>
                        <Typography
                            category="subtitle"
                            size="small"
                            weight="bold"
                        >
                            Opened
                        </Typography>
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                        >
                            25
                        </Typography>
                    </FolderInformationSlideoutMeta>

                </FolderInformationSlideoutMetaContainer>

                <FolderInformationSlideoutMetaContainer>
                    <FolderInformationSlideoutMeta>
                        <Typography
                            category="subtitle"
                            size="small"
                            weight="bold"
                        >
                            Location
                        </Typography>
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                        >
                            My Worspace
                        </Typography>
                    </FolderInformationSlideoutMeta>

                    <FolderInformationSlideoutMeta>
                        <Typography
                            category="subtitle"
                            size="small"
                            weight="bold"
                        >
                            Documents inside
                        </Typography>
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                        >
                            24
                        </Typography>
                    </FolderInformationSlideoutMeta>
                </FolderInformationSlideoutMetaContainer>

                <FolderInformationSlideoutActions>
                    <Button
                        label="Shared"
                        size="medium"
                        type="secondary"
                        iconLeft="share"
                    />
                </FolderInformationSlideoutActions>
            </FolderInformationSlideoutContainer>
        </Slideout>
    )
}
export default FolderInformationSlideout
